/* eslint-disable camelcase */
// import sample from '@sample/account/users.json'
import axios from '@axios'

export const state = {
  accounts: [],
  documents: [],
  account_pagination: {},
  currentPage: 1,
  perPage: 15,
  totalPages: 1,
  totalRecords: 0,
}

export const getters = {
  allAccounts: (state) => state.accounts,
  allDocuments: (state) => state.documents,
  currentPage: (state) => state.currentPage,
  totalPages: (state) => state.totalPages,
  perPage: (state) => state.perPage,
  totalRecords: (state) => state.totalRecords,
}

export const mutations = {
  GET_ACCOUNTS: (state, data) => {
    if (!data) return false
    let { users, page, totalPages, perPage, totalRecords } = data
    state.accounts = users
    state.currentPage = page
    state.totalPages = totalPages
    state.perPage = perPage
    state.totalRecords = totalRecords
  },
  GET_DOCUMENTS: (state, data) => {
    if (!data) return false
    state.documents = data
  },
  UPDATE_DOCUMENTS: (state, data) => {
    if (!data) return false

    data.forEach((element) => {
      state.documents.push(element)
    })
  },

  CREATE_ACCOUNT: (state, user) => {
    state.accounts.unshift(user)
  },

  UPDATE_PROFILE: (state, user) => {
    for (let i = 0; i < state.accounts.length; i++) {
      if (state.accounts[i].id === user.id) {
        for (let field in state.accounts[i]) {
          state.accounts[i][field] = user[field]
        }
        break
      }
    }
  },

  TOGGLE_USER_STATUS: (state, user) => {
    for (let i = 0; i < state.accounts.length; i++) {
      if (state.accounts[i].id === user.id) {
        state.accounts[i].status = user.status
        break
      }
    }
  },
  ACTIVATE_USER: (state, user) => {
    for (let i = 0; i < state.accounts.length; i++) {
      if (state.accounts[i].id === user.id) {
        state.accounts[i].activated = user.activated
        state.accounts[i].status = user.status
        break
      }
    }
  },
}

export const actions = {
  async updateAccount({ commit, dispatch }, account) {
    return axios.put(`/users/me`, account)
  },
  async getDocuments({ commit, dispatch }, params) {
    return axios
      .get(`/users/profile/upload-documents`, { params: params })
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_DOCUMENTS', resp.data.medias)
        } else {
          commit('GET_DOCUMENTS', [])
        }
      })
      .catch(() => {
        commit('GET_DOCUMENTS', [])
      })
  },
  async createDocuments({ commit, dispatch }, user = {}) {
    let form = new FormData()
    for (let field in user.form) {
      form.append(field, user.form[field])
    }
    return axios.post(`/users/profile/upload-document`, form, {
      params: { userId: user.userId },
    })
  },
  async getAccounts({ commit, dispatch }, params = {}) {
    dispatch('layout/changeLoading', true, { root: true })
    return axios
      .get(`/users`, { params: params })
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_ACCOUNTS', resp.data)
          dispatch('layout/changeLoading', false, { root: true })
        }
      })
      .catch(() => {
        dispatch('layout/changeLoading', false, { root: true })
      })
      .finally(() => {
        dispatch('layout/changeLoading', false, { root: true })
      })
  },
  async getAccountsForDropDown({}, params) {
    return axios.get(`/users`, { params: params })
  },

  async getAccount({ commit }, users) {
    if (users.hasOwnProperty('id'))
      return axios.get(`/users/profile/${users.id}`)
    return axios.get(`/users/profile`)
  },
  async createSubAccount({ commit, dispatch }, plyload = {}) {
    let { params, body } = plyload
    dispatch('layout/changeLoading', true, { root: true })
    await axios.post(`/users/new`, body, { params: params }).then((resp) => {
      if (resp.status === 201) {
        commit('CREATE_ACCOUNT', resp.data)
      }
    })
  },

  async updateProfile({ commit }, datas) {
    await axios.put('/users/profile', datas.user).then((resp) => {
      if (resp.status === 200) {
        commit('UPDATE_PROFILE', resp.data)

        // Check status to update top bar
        if (datas.hasOwnProperty('isSelfProfile')) {
          if (datas.isSelfProfile)
            commit('auth/SET_PROFILE', resp.data, {
              root: true,
            })
        }
      }
    })
  },
  async updateProfileReturn({}, datas) {
    return axios.put('/users/profile', datas)
  },
  async toggleAccountStatus({ commit, dispatch }, user = {}) {
    await axios
      .patch(`/users/${user.id}/toggle-status`)
      .then((resp) => {
        if (resp.status === 200) {
          commit('TOGGLE_USER_STATUS', resp.data)
        }
      })
      .catch(() => {
        let status = user.status ? 'disable' : 'enable'
        let notification = {
          id: Date.now(),
          message: `Failed to ${status} the user.`,
          type: 'error',
          title: 'Toggle status',
        }
        dispatch('notification/addNotification', notification, {
          root: true,
        })
      })
  },
  async activateAccount({ commit }, user = {}) {
    await axios.patch(`/users/${user.id}/activate`).then((resp) => {
      if (resp.status === 200) {
        commit('ACTIVATE_USER', resp.data)
      }
    })
  },

  async disableMfa({ commit }, user = {}) {
    await axios.patch(`/auth/disable-mfa/${user.id}`).then((resp) => {
      if (resp.status === 200) {
      }
    })
  },
  async transferParent({ commit, dispatch }, user = {}) {
    return axios.put(`/users/transfer-parent`, user)
  },
  async independentAccount({}, userId = 0) {
    return axios.patch(`/users/${userId}/independent`)
  },
}
